export interface IImpersonation {
    start(userId: string): void;
    stop(): void;
}
